
  // Draws a listbox over each variant <select> so the closed and open states
  // share one design. The native control is kept, hidden, and remains the
  // source of truth: every choice writes to it and fires a bubbling `change`,
  // which is what variant-selects.js and the rest of the theme listen for.
  // If this script never runs, the untouched native select is still usable.
  (function () {
    if (window.tcVariantPickerReady) return;
    window.tcVariantPickerReady = true;
    var root = document;

    function enhance(wrap) {
      if (wrap.dataset.optSelectReady) return;
      var select = wrap.querySelector('select');
      if (!select) return;
      wrap.dataset.optSelectReady = 'true';
      wrap.classList.add('is-enhanced');

      var trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'opt-select__trigger';
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.innerHTML =
        '<span class="opt-select__value"></span>' +
        '<svg class="opt-select__chevron" viewBox="0 0 12 8" fill="none" aria-hidden="true">' +
        '<path d="M1 1.5 6 6.5l5-5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      var panel = document.createElement('ul');
      panel.className = 'opt-select__panel';
      panel.setAttribute('role', 'listbox');
      panel.hidden = true;

      var label = trigger.querySelector('.opt-select__value');

      function build() {
        panel.textContent = '';
        Array.prototype.forEach.call(select.options, function (option) {
          var li = document.createElement('li');
          li.className = 'opt-select__option';
          li.setAttribute('role', 'option');
          li.textContent = option.textContent.trim();
          li.dataset.value = option.value;
          li.setAttribute('aria-selected', option.value === select.value ? 'true' : 'false');
          if (option.disabled) li.setAttribute('aria-disabled', 'true');
          panel.appendChild(li);
        });
        label.textContent = select.selectedOptions.length
          ? select.selectedOptions[0].textContent.trim()
          : '';
      }

      function open(state) {
        panel.hidden = !state;
        trigger.setAttribute('aria-expanded', String(state));
      }

      trigger.addEventListener('click', function () {
        open(panel.hidden);
      });

      panel.addEventListener('click', function (event) {
        var li = event.target.closest('.opt-select__option');
        if (!li || li.getAttribute('aria-disabled') === 'true') return;
        if (select.value !== li.dataset.value) {
          select.value = li.dataset.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        build();
        open(false);
      });

      // Re-sync when anything else changes the variant (URL, quick add, etc).
      select.addEventListener('change', build);


      wrap.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          open(false);
          trigger.focus();
        }
      });

      wrap.appendChild(trigger);
      wrap.appendChild(panel);
      build();
    }

    function init() {
      root.querySelectorAll('variant-selects.tc-variant-picker [data-opt-select]').forEach(enhance);
    }

    document.addEventListener('click', function (event) {
      root.querySelectorAll('variant-selects.tc-variant-picker [data-opt-select]').forEach(function (wrap) {
        if (!wrap.contains(event.target)) {
          var panel = wrap.querySelector('.opt-select__panel');
          var trigger = wrap.querySelector('.opt-select__trigger');
          if (panel) panel.hidden = true;
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
        }
      });
    });
    init();
    // The section re-renders in the theme editor and on some variant updates.
    new MutationObserver(init).observe(document.documentElement, { childList: true, subtree: true });
  })();
